import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LoadingService } from '../../shared/services/loading.service';

@Component({
  selector: 'app-loading-component',
  templateUrl: 'loading.component.html'
})

export class LoadingComponent implements OnInit {

  // tslint:disable-next-line:no-output-on-prefix no-output-rename
  @Output('onLoaded') private onLoaded: EventEmitter<LoadingComponent> = new EventEmitter<LoadingComponent>();

  public opened = false;
  private backdropElement: HTMLElement;

  constructor(
    private loadingService: LoadingService
  ) {
    this.backdropElement = document.createElement('div');
    this.backdropElement.classList.add('modal-backdrop');
    this.backdropElement.classList.add('fade');
    this.backdropElement.classList.add('show');
  }

  public ngOnInit(): void {
    this.onLoaded.emit(this);
  }

  public open(): boolean {
    document.body.appendChild(this.backdropElement);
    document.body.className = document.body.className.replace(/ modal-open\b/, '');
    document.body.className += ' modal-open';
    this.opened = true;
    return false;
  }

  public close(): boolean {
    if (!this.opened) {
      return false;
    }
    document.body.removeChild(this.backdropElement);
    document.body.className = document.body.className.replace(/ modal-open\b/, '');
    this.opened = false;
    return false;
  }

  public isOpened(): boolean {
    return (this.opened === true);
  }
}
